<template>

<div class="list-view">

	<h1>Feature Requests</h1>

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters" v-if="showFilters">

		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
				<label>Hidden</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
				<label>Inactive</label>
			</li>
		</ul>

		<div class="divider"></div>

		<div class="button action" @click="addItem()">Add</div>
		<div :class="['button', gettingExport ? 'disabled' : 'action']" @click="doExport()">Export CSV</div>

		<div class="message">{{ exportMessage }}</div>

	</div>

	<loading v-if="loading" class="loading" />

	<div v-else-if="showDetail" class="list-detail">

		<div>PLACEHOLDER: item detail</div>

		<div class="controls">
			<button :class="['button', canSave ? 'action' : 'disabled']" @click="saveItem()">Save</button>
			<div class="message">{{ saveMessage }}</div>
		</div>

	</div>

	<div v-else class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

		<div v-else>
			<div>PLACEHOLDER: item list</div>
		</div>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
import Loading from '@/components/Loading.vue'
export default {
	name: 'generic-view',
    components: {
        'loading': Loading
    },
	data() {
		return {
            loading: false,
			message: '',
			showPagination: false,
			showFilters: true,
			featureRequestStatusCodes: [],
			filters: {},
			filterMessage: '',
			filterLoading: false,
			list: [],
			paging: {},
			showDetail: false,
			listDetail: {},
			gettingExport: false,
			exportMessage: ''
		}
	},
	created() {
		console.log(this.getAdministratorFlag)
		//this.getListStatusCodes()
		//this.clearFilters()
	},
	computed: {
		canSave() {
			return true
		}
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				internal_use_only: 0,
				inactive: 0,
				do_export: 0
			}
			this.getList()
		},
		getListStatusCodes() {
			this.apiCall({ destination: 'get_list_feature_request_status' }).then(obj => {
				if (obj.status == 'success') {
					this.featureRequestStatusCodes = obj.list
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_list_feature_requests', data: this.filters }).then(obj => {
				this.loading = false
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
					if (obj.paging) {
						this.paging = obj.paging
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getItem(item) {
			// NOTE: this will typically be an api action
		},
		addItem() {
			this.listDetail = {
				description: '',
				internal_use_only: 0,
				inactive: 0
			}
			this.showDetail = true
		},
		saveItem() {
			// NOTE: this will be an api action to save edited detail
		},
		backToList() {
			this.listDetail = {}
			this.showDetail = false
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
